<div *adaptLoading="isProcessing"
     class="m-4">
    @if (emailConfirmed) {
        <h1>Email confirmed!</h1>
    } @else {
        <h2>Email confirmation failed</h2>
    }

    @if (errorMessage) {
        <div class="my-3 alert alert-danger">{{ errorMessage }}</div>
    }

    <button adaptButtonIcon="previous"
            class="btn-primary"
            (click)="goHome()">Back to home</button>
</div>
